// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1vkuE","content":"styles_content__PCcbR","checkbox":"styles_checkbox__fu5P1","checkboxLabel":"styles_checkboxLabel__3Lged"};